export default __webpack_public_path__ + "static/media/yellow_pawn.a947eb83.png";